module.exports = __webpack_public_path__ + "img/medicallogo.e6d5d1e9.png";